/**
 * cookie-settings.js — <cookie-settings>, the footer link that reopens the consent banner.
 *
 * Why it exists: GDPR requires withdrawing consent to be as easy as giving it, and the cookie
 * policy promises a cookie-settings link in the footer. The banner belongs to the Cookiebot CMP
 * app embed, which exposes `window.Cookiebot.renew()` to reopen it.
 *
 * The button is rendered `hidden` and only shown once Cookiebot is present, so a page where the
 * app embed is off (or blocked) never shows a control that does nothing. Cookiebot either loaded
 * before this upgraded, or announces itself with `CookiebotOnLoad` on window.
 */
(() => {
  if (customElements.get('cookie-settings')) return;

  class CookieSettings extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.onClick = () => window.Cookiebot && window.Cookiebot.renew();
      this.onLoad = () => this.reveal();
      this.button.addEventListener('click', this.onClick);
      if (window.Cookiebot) this.reveal();
      else window.addEventListener('CookiebotOnLoad', this.onLoad);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onClick);
      window.removeEventListener('CookiebotOnLoad', this.onLoad);
    }

    reveal() {
      this.hidden = false;
    }
  }

  customElements.define('cookie-settings', CookieSettings);
})();
